import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IComment } from 'models/common';
import { IAdminItemCardButtonsProps, IItemCardProps } from 'models/itemcard';
import { StarsRating } from '../../../Common/StarsRating';
const { connect } = require('react-redux');
import { IModalAction } from 'models/modal';
import { closeModal, showModal } from 'redux/modules/modal';
import { AdminItemCardButtons } from 'components/ItemList/ItemCard/AdminItemCardButtons';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { actions as notifActions } from 'redux-notifications';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IComment;
	itemSettings?: (itemId: string) => void;
	t?: (key: string, options?: any) => string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	viewItem?: (id: any) => any;
	showNotification?: (message: string, kind: string) => void;
}

@connect(null, (dispatch) => ({
	closeModal: () => dispatch(closeModal()),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	viewItem: (id: string) => dispatch(getShopCard(id)),
	showNotification: (message: string, kind: string, dismissAfter = 3000) =>
		dispatch(notifActions.notifSend({ message, kind, dismissAfter })),
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminShopReviewItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.handleApproveShopReviewButtonClick = this.handleApproveShopReviewButtonClick.bind(this);
		this.handleDeleteShopReviewButtonClick = this.handleDeleteShopReviewButtonClick.bind(this);
		this.deleteReview = this.deleteReview.bind(this);
		this.viewItem = this.viewItem.bind(this);
	}

	private handleApproveShopReviewButtonClick() {
		if (this.props.customFunction) {
			this.props.customFunction(this.props.item.id, 'approve');
		}
	}

	private deleteReview(yes: boolean) {
		const { t } = this.props;

		if (yes === true) {
			this.props.customFunction(this.props.item.id, 'delete');
			this.props.closeModal();
			this.props.showNotification(t('Notification_Success_ShopReview_Declined'), 'success');
		} else {
			this.props.closeModal();
		}
	}

	private handleDeleteShopReviewButtonClick() {
		const { t, showModal, closeModal } = this.props;
		if (typeof this.props.customFunction !== 'function' || !showModal || !closeModal) {
			return;
		}

		const dialogContent = (
			<div className="confirmationDialogModal__contentContainer">
				<img src={require('containers/Html/icons/icon_notification.png')} />
				<h2>{t('Administration_ShopReviews_Delete_Title')}</h2>
				<p>{t('Administration_ShopReviews_Delete_Subtitle')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deleteReview,
			value: this.props.item.id,
			yesButtonText: t('BSPortal_Common_YesDelete'),
			noButtonText: t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	public viewItem(e: any) {
		e.stopPropagation();
		if (this.props.viewItem) {
			this.props.viewItem(this.props.item.parentId);
		}
	}

	public render() {
		const { item } = this.props;

		const adminItemCardButtonsProps: IAdminItemCardButtonsProps = {
			viewItem: this.viewItem,
			deleteItem: this.handleDeleteShopReviewButtonClick,
			publishItem: this.handleApproveShopReviewButtonClick,
		};

		return (
			<div className="adminItemCard adminShopReviewItemCard">
				<div className="innerHolder">
					<div className="middle">
						<div className="description"></div>

						<br />
					</div>
					<div className="title">{item.body}</div>
					<div className="author">{item.addedBy}</div>
					<div className="created-date">
						{item.rating ? (
							<div>
								<StarsRating rating={item.rating} editing={false} />
							</div>
						) : null}
					</div>
					<div className="control-big">
						<AdminItemCardButtons {...adminItemCardButtonsProps} />
					</div>
				</div>
			</div>
		);
	}
}

export { AdminShopReviewItemCard };
